export default __webpack_public_path__ + "static/media/close-icon-gray.67b76162.svg";